/**
 * The deck — shared by Andar Bahar and Teen Patti. Pure data: ranks, suits,
 * a 52-card deck, a seeded Fisher-Yates shuffle. No art here (the SVG deck
 * lives in _cards/art.ts once designed); no money.
 */

export type Suit = 's' | 'h' | 'c' | 'd';
export type Rank = 'A' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | 'J' | 'Q' | 'K';
export type Card = { rank: Rank; suit: Suit };

export const SUITS: readonly Suit[] = ['s', 'h', 'c', 'd'];
export const RANKS: readonly Rank[] = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K'];

/** rank value A=1 … K=13 (Teen Patti ranks A high; see teen_patti/engine) */
export const rankValue = (r: Rank): number => RANKS.indexOf(r) + 1;
export const isRed = (c: Card): boolean => c.suit === 'h' || c.suit === 'd';
export const cardId = (c: Card): string => `${c.rank}${c.suit}`;

export function freshDeck(): Card[] {
  const d: Card[] = [];
  for (const suit of SUITS) for (const rank of RANKS) d.push({ rank, suit });
  return d;
}

/** in-place Fisher-Yates with an injected rng ∈ [0,1) — deterministic for tests */
export function shuffle<T>(arr: T[], rng: () => number): T[] {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}
